import {
  LANGUAGE_PREVIEW,
  LANGUAGE_NEW,
  LANGUAGE_UPDATE,
  LANGUAGE_REMOVE,
  LANGUAGE_PROCESS_SUCCESS,
  LANGUAGE_DATASOURCE_SUCCESS,
  LANGUAGE_SEARCH,
  LANGUAGE_PROCESS_RESET
  
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LANGUAGE_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case LANGUAGE_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case LANGUAGE_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case LANGUAGE_REMOVE: {
      return {
          ...state,
          loader: false
      }
    }
    case LANGUAGE_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case LANGUAGE_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case LANGUAGE_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case LANGUAGE_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}